<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>

<style>
  .mx-input {
    height: 35px !important;
  }

  .btn-secondary {
      background-color: #fff !important;
  }



  .rowborder {
      border-bottom: 1px solid lightgray !important;
  }
  .rowborder:last-child {
      border-bottom: none !important;
  }

  /* Used when edit a striped table */
  .table-striped > tbody > tr:nth-child(odd).editable > td {
      background-color: rgb(255, 255, 200);
      cursor: pointer;
  }

  .table-striped > tbody > tr:nth-child(even).editable > td {
      background-color: lightyellow;
  cursor: pointer;
  }

  /* End edit striped table */

  .multiselect, .multiselect__single, .multiselect__input
  {
        font-size: inherit !important;
  }
  .multiselect__tags {
      min-height: none !important;
      
  }
  .multiselect__placeholder {
      font-size: inherit !important;
      color: #5c6873 !important;
  }   


</style>

